import React, { useState, useCallback, useEffect } from "react"
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@mui/material"
import MuiModal from "../shared/mui_modal"
import { devices as devicesClient } from "../../ajax_clients"
import { visitURL } from "../../shared/query"

function closeBootstrapDropdownMenu(anchor) {
  let node = anchor?.parentElement
  while (node && node !== document.documentElement) {
    if (node.classList?.contains("open")) {
      node.classList.remove("open")
      break
    }
    node = node.parentElement
  }
}

export default function UnenrollDevice(props) {
  const { hasDirectProfileAssignments, deviceId } = props
  const [modalOpen, setModalOpen] = useState(false)
  const [unassignDirectProfiles, setUnassignDirectProfiles] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const submitUnenroll = useCallback(
    (unassignDirectProfiles) => {
      setSubmitting(true)
      devicesClient
        .unenroll(deviceId, { unassignDirectProfiles: unassignDirectProfiles })
        .done((data) => {
          setModalOpen(false)
          visitURL(data.redirect_to || AdminRoutes.adminDevicePath(deviceId, { format: null }))
        })
        .fail(() => {
          setSubmitting(false)
        })
    },
    [deviceId],
  )

  useEffect(() => {
    const trigger = document.getElementById("device-unenroll-menu-trigger")
    if (!trigger) {
      return undefined
    }
    const onClick = (e) => {
      e.preventDefault()
      closeBootstrapDropdownMenu(trigger)
      setUnassignDirectProfiles(false)
      setModalOpen(true)
    }
    trigger.addEventListener("click", onClick)
    return () => trigger.removeEventListener("click", onClick)
  }, [])

  const handleClose = useCallback(() => {
    if (!submitting) {
      setModalOpen(false)
    }
  }, [submitting])

  const handleCommit = useCallback(() => {
    submitUnenroll(unassignDirectProfiles)
  }, [submitUnenroll, unassignDirectProfiles])

  if (!modalOpen) {
    return null
  }

  return (
    <MuiModal
      titleText="Unenroll Device"
      buttonText="Unenroll"
      onClose={handleClose}
      onCommit={handleCommit}
      commitDisabled={submitting}
    >
      <Grid container spacing={2} sx={{ minHeight: "80px" }}>
        <Grid item xs={12}>
          <p>SimpleMDM will lose contact with the device. Are you sure?</p>
          {hasDirectProfileAssignments ? (
            <>
              <FormControlLabel
                label="Unassign directly assigned profiles"
                control={
                  <Checkbox
                    checked={unassignDirectProfiles}
                    disabled={submitting}
                    onChange={() =>
                      setUnassignDirectProfiles((prev) => !prev)
                    }
                  />
                }
              />
              <FormHelperText>
                Removes directly assigned profiles from the device record. This
                prevents them from being re-applied automatically after
                re-enrollment.
              </FormHelperText>
            </>
          ) : null}
        </Grid>
      </Grid>
    </MuiModal>
  )
}
